///////////// auth url
// reset password
export const generateOtpResetPasswordUrl = "/passwordrecovery";
export const resetPasswordUrl = "/ChangePassword";
export const validateOtpResetPasswordUrl = "/passwordrecovery";

// login
export const loginUrl = "/login";
export const userRegisterUrl = "/registration";

// register List
export const getCitiesUrl =
  "http://manar.ddns.net:1551/ords/etihadapi/CountriesCities/";
export const getCountriesUrl =
  "http://manar.ddns.net:1551/ords/etihadapi/Countries/GetAll";
export const getTitlesUrl =
  "http://manar.ddns.net:1551/ords/etihadapi/FirstTitles/GetAll";
///////////////////////////////////////////////////////////

// cart
export const userGetCartItemsUrl = "/cart/fetch/v1/web/";
export const userAddCartItemsUrl = "/cart/project/v1/web/";
export const adjustCartItemUrl = "/cart/project/v1/web/";
export const userDeleteCartItemsUrl = "/cart/delete/v1/web/";

// contact us
export const contactUsFormUrl = "/contact-us/form/v1/web/en/user/";

// donations history
export const donationHistoryUrl = "/donationhistory";

// CampaignList
export const campaignListUrl = "/Campaign";

// humanitarain Cases
export const humanitarainCasesUrl = "/HelpingCase/";

// same project details with diffrent query param
// internal Projects    (it has params "donation=Charity Projects")
export const internalProjectsUrl = "/DonationMaster";

// seasonal Projects    (it has params "donation=Seasonal Projects")
export const seasonalProjectsUrl = "/DonationMaster";
/////////////////////////////////////////////////

// news List    (it has params )
export const newsListUrl = "/news";
export const singleNewsUrl = "/news/";

//news Letter
export const newsLetterUrl = "/news";

// get Orphans List
export const getOrphansListUrl = "/orphan";

///////////// projects details  (with the ID as query param)
// for the donation projects we use the same internal projets URL
// for the human cases we use the same humanitarainCasesUrl
// for the Recent Projects we use the same campaignListUrl

// quick donate
export const quickDonateUrl = "/donationmaster";

// request secure url
export const requestSecureUrlUrl = "/online-payment/secure/v1/web/";

// sms Donation
export const smsDonationUrl = "/smscode";

// videos list ( it has param "file_type=${type}")
export const videosUrl = "/Gallery";

// payment Status ( it has query params "?refid=web-${id}")
export const paymentStatusUrl = "/TransactionStatus";

//////////////////// external projects
export const getExternalProjectCategoryUrl = "/external-project/types/v1/web";

export const getExternalProjectSubCategorytUrl =
  "/external-project/subtypes/v1/web";

export const getCountriesExternalProjectsUrl =
  "/external-project/countries/v1/web/14?page=1&pageSize=10";

export const getExternalProjectsListUrl = "/external-project/list/v1/web";

export const getExternalProjectDetailsUrl = "/external-project/list/v1/web";
/////////////////////////// user profile
export const getUserDetailsByUserIdUrl = "/account/v1/web/user-details/3";

export const updateUserDetailsByUserIdUrl =
  "/account/{version}/{device}/{lang}/user/{user_id}";
